import { NgModule } from '@angular/core';

import { CommonModule } from "@angular/common";
import { PopupMenuModule } from "libraries/component/popup-menu/popup-menu.module";
import { SorterComponent } from "./sorter.component";
import { BtnModule } from "libraries/ui_button/btn.module";
import { LabelModule } from "libraries/service/label/label.module";
import { SimpleStorageModule } from "libraries/service/simple-storage/simple-storage.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        CommonModule,
        PopupMenuModule,
        BtnModule,
        LabelModule,
        SimpleStorageModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    exports: [SorterComponent],
    declarations: [SorterComponent],
    providers: [],
})
export class SorterModule {
}
